export default "__VITE_ASSET__09495dde__"